export const ROLE_PRIVILEGE = {
    IsProgramAdmin: "IsProgramAdmin",
    CreateTestEnvironment: "CanCreateTestEnvironment",
    EditActions: "CanEditActions",
    EditCommunications: "CanEditCommunications",
    EditDashboardColumns: "CanEditDashboardColumns",
    EditDataFields: "CanEditDataFields",
    EditDeadlines: "CanEditDeadlines",
    EditDocumentTemplates: "CanEditDocumentTemplates",
    EditForms: "CanEditForms",
    EditFrontPage: "CanEditFrontPage",
    EditIncentiveDesigns: "CanEditIncentiveDesigns",
    EditProgramInfo: "CanEditProgramInfo",
    EditRoles: "CanEditRoles",
    EditUsers: "CanEditUsers",
    EditWorkflow: "CanEditWorkflow",
    EditReports: "CanEditReports",
    ImportData: "CanImportData",
    EditFormulas: "CanEditFormulas",
    EditAutomations: "CanEditAutomations",
    UseV2Import: "CanUseV2Import",
    IsDeleted: "IsDeleted",
    IsSelfRegisterable: "IsSelfRegisterable",
    EditProjectOwner: "CanEditProjectOwner",
    ViewForms: "CanViewForms",
    ViewWorkflow: "CanViewWorkflow",
    AccessAdminPage: "CanAccessAdminPage",
    ChangeStatusOutsideWorkflow: "CanChangeStatusOutsideWorkflow",
    EditStatusDate: "CanEditStatusDate",
    ViewSharedReports: "CanViewSharedReports",
    EditBusinessCalendar: "CanEditBusinessCalendar",
    EditCustomIds: "CanEditCustomIds",
    EditCrossReportMapping: "CanEditCrossReportMapping",
    EditReportAdapter: "CanEditReportAdapter",
    EditProjectDuplicateConfig: "CanEditProjectDuplicateConfig",
    ManageExternalData: "CanManageExternalData",
    ViewSensitiveData: "CanViewSensitiveData",
    ViewDashboard: "CanViewDashboard",
    EditDashboard: "CanEditDashboard",
    ViewDataFields: "CanViewDataFields",
    AssignProjectAccessGroups: "CanAssignAccessGroups",
    ProjectAdminCanViewAllSubmittedFormsOnAdminPage: "ProjectAdminCanViewAllSubmittedFormsOnAdminPage",
    ProjectAdminCanAccessAdminForms: "ProjectAdminCanAccessAdminForms",
    ProjectAdminCanCorrectSubmittedForms: "ProjectAdminCanCorrectSubmittedForms"
};
